import { render, staticRenderFns } from "./editOwner.vue?vue&type=template&id=4fe21dd8&scoped=true"
import script from "./editOwner.vue?vue&type=script&lang=js"
export * from "./editOwner.vue?vue&type=script&lang=js"
import style0 from "./editOwner.vue?vue&type=style&index=0&id=4fe21dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe21dd8",
  null
  
)

export default component.exports